/* @flow */

import getInputPorId from '../../utils/get-input-por-id';
import api from '../../utils/api';
import uploads from '../../empresa/uploads';
import getFileImagemInput from '../../utils/get-file-imagem-input';

import { type Empresa } from '../../empresa/types';

const preencherFormularioWebLoja = (empresa: Empresa) => {
    getInputPorId('identificador').value = empresa.identificador;
};

const getDadosFormularioWebLoja = (): Empresa => ({
    identificador: getInputPorId('identificador').value,
});

const editarDadosWebLoja = (empresasId: number, empresa: Empresa) => {
    const fileCapaWebLoja: File | null = getFileImagemInput('imagem-capa-web-loja');
    api.updateEmpresa(empresasId, empresa);

    if (fileCapaWebLoja) {
        const name = `${empresa.identificador}.png`;
        uploads.capaWeb(fileCapaWebLoja, `/empresa/capa-web?empresasId=${empresasId}&name=${name}`);
    }
};

export {
    preencherFormularioWebLoja,
    getDadosFormularioWebLoja,
    editarDadosWebLoja,
};
